






































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import { capitalize } from "lodash";
import moment from "moment";
import "moment-timezone";
import { duration, paginate } from "@/helpers";
import { collections } from "@/configs/firebase";
import { User } from "@/types";
import logger from "@/configs/logger";
import VuetifyAudio from "@/components/VuetifyAudio.vue";
import * as api from "@/lib/api";
import { Routes } from "@/router/routes";

@Component({ components: { VuetifyAudio } })
export default class AgentCalls extends Vue {
  @Prop() loading!: boolean;
  @Prop() lead!: any;
  @State("inCallMode") calling!: boolean;
  @State("user") user!: User;
  @Action("changeCallMode") changeCallMode!: Function;

  @Watch("calling")
  onCallModeChange(val: any, preVal: any) {
    this.leadDialog = false;
  }

  loadingLead = false;
  leadDialog = false;
  page = 1;
  itemsPerPage = 20;
  loadingCallHistory = false;
  callHistory: any[] = [];
  audioDialog = false;
  audioLink: string = "";

  async mounted() {
    this.loadingCallHistory = true;
    this.callHistory = await this.getLeadCallHistory(this.lead.id);
    this.loadingCallHistory = false;
  }

  get isAdmin() {
    return this.user.roles.includes("admin");
  }

  get totalPages() {
    return Math.ceil(this.items.length / this.itemsPerPage);
  }

  get currentPage() {
    return paginate(this.items, this.itemsPerPage, this.page);
  }

  get items(): any[] {
    let items: any = [];

    this.callHistory.forEach((call, index) => {
      items.push({
        taskId: call.task_sid,
        conferenceId: call.conference_sid,
        agent: call.reservation_user_email || "",
        leadId: call.lead_key.split("/")[1],
        callSource: call.call_source,
        taskSource: capitalize(call.task_creation_source.replace(/_/g, " ")),
        leadSource: call.lead_source,
        leadName: call.lead_name || "",
        disposition: call.disposition,
        conferenceSid: call.conference_sid,
        qualifiedStatus: call.qualified_status,
        transferFrom: call.transfer_from_user_email,
        time: moment
          .unix(call.created_ts ? call.created_ts.seconds : 0)
          // @ts-ignore
          .tz("America/New_York")
          .format("MMMM Do YYYY, h:mm:ss a"),
        leadPhoneNumber: call.lead_phone_number || "",
        duration:
          call.created_ts && call.call_ended_ts
            ? this.getCallDuration(
                call.created_ts.seconds,
                call.call_ended_ts.seconds
              )
            : "",
        snippedRecordingKey: call.snipped_recording_key
      });
      if (index < this.callHistory.length) {
        items.push({ divider: true, inset: true });
      }
    });

    return items;
  }

  async getLeadCallHistory(leadId: string) {
    try {
      const leadKey = `lead/${leadId}`;
      const snap = await collections.taskAttribute
        .where("lead_key", "==", leadKey)
        .orderBy("created_ts", "desc")
        .get();

      return snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    } catch (err) {
      this.$toasted.error("Fetch call history error").goAway(2000);
      logger("error", "Fetch history error", err);
      return [];
    }
  }

  getConferenceLink(task: any): string {
    return `https://www.twilio.com/console/voice/conferences/logs/${task.conferenceSid}`;
  }

  getCallDuration(startSec: number, endSec: number): string {
    const start = moment.unix(startSec);
    const end = moment.unix(endSec);
    const secs = end.diff(start, "seconds");
    return duration(secs);
  }

  viewEvents(taskSID: string) {
    this.$router.push({
      name: Routes.TwiloEvents,
      params: { taskSID: taskSID }
    });
  }

  async handleRecording(snippedRecordingKey: string) {
    try {
      const resp = await api.getSnippedRecordingDownloadLink(
        snippedRecordingKey
      );
      this.audioLink = resp.data;
      this.audioDialog = true;
    } catch (err) {
      logger("error", "donwload snipped recording failed", err);
      this.$toasted.error("Download recording failed").goAway(2000);
    }
  }
}
